import { gql } from "@apollo/client";

export const BUILDING_WAITLIST_FIELDS_FRAGMENT = gql`
  fragment BuildingWaitlistFieldsV2 on BuildingInterface {
    id
    slug
    moveInRequirements
    availability {
      status
      bedrooms
      units {
        id
        deleted
        unitType
        unitCount
        fcfsUnitCount
        fcfsUnitCount
        bathroomCount
        mobilityAccessible
        visionAccessible
        hearingAccessible
        rentType
        floating
        ami
        minIncome
        rentalCost
        isAffordable
        maxIncomes {
          id
          householdSize
          maxIncome
        }
      }
    }
    url
    applicationUrl
    hasPreferences
    preferences {
      id
      kind
      condition
      details
    }
    __typename
  }
`;

export default BUILDING_WAITLIST_FIELDS_FRAGMENT;
